import { createFileRoute } from '@tanstack/react-router';
import { BookingsAnalytics } from '@/pages/bookings/BookingsAnalytics';

export const Route = createFileRoute('/_authenticated/_app/bookings/dashboard')({
	component: BookingsAnalytics,
});
